import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import { officials } from "../../../apis/urls";
import { $ } from "react-jquery-plugin";




const OfficialView = () => {



    useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        $('html,body').animate({ scrollTop: 0 }, 'fast');

        // setTimeout(() => {
            Listing();
            // });
    }, []);
    const role = localStorage.getItem('userrole');
    
    let navigate = useNavigate();

    const { id } = useParams();
    const { assid } = useParams();

    const [result, setResult] = useState([]);
    const [sportresult, setSportResult] = useState([]);

    let arr = localStorage.getItem('association');

    let associationIds = arr.split(',');

    const Listing = () => {
        
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: officials + "/association/"+assid+'/'+ id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            setResult(res.data.data);
            setSportResult(res.data.data.sport);
            console.log("datas", res.data.data);    
            // setLoader(false)
        });
    }


    const DeleteOfficial = (oid) => {
        let r = window.confirm("Are you sure you want to delete this official?");

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: officials+'/association/'+id+'/'+oid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
               Listing();

               let userrole = localStorage.getItem('userrole');


               if(userrole === 'SUPERADMIN'){
                navigate("/officials/"+assid)
                }else{
                   navigate("/association_officials/"+assid)
               }
               
               
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }



    return(
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title">Official View</h2>
                        </div>

                        <div class="page-rightside-action-column"></div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            {
                              role === 'ASSOCIATION_USER' ? (
                              associationIds.length === 1?null:
                                <li className="breadcrumb-item"><Link to="/select_association">Home</Link></li>):
                                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            }

                            {
                              role === 'ASSOCIATION_USER' ?null :
                              (
                                <li className="breadcrumb-item"><Link to="/associations"> Association List</Link></li>
                              )
                            }
                            
                            {
                              role === 'ASSOCIATION_USER' ? 
                              <li className="breadcrumb-item"><Link to={"/association_officials/"+assid}> Officials List</Link></li>
                              :
                            <li className="breadcrumb-item"><Link to={"/officials/"+assid}> Officials List</Link></li>
                            }

                            <li className="breadcrumb-item active" aria-current="page">Official View</li>
                        </ol>
                    </nav>

                    <div className="tab-content">

                        <div id="generalinfo" class="containerss tab-pane active"><br/>
                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>First Name</label>
                                    <div>{result.firstname}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Last Name</label>
                                    <div>{result.lastname}<br/>   
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Email</label>
                                    <div style={{cursor: 'pointer'}} onClick={() => window.location = 'mailto:'+result.email}>{result.email}<br/>
                                    </div>
                                </div>
                                
                            
                                
                            </div>
                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Address 1</label>
                                    <div>{result.address_1}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>Address 2</label>
                                    <div>{result.address_2}<br/>   
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>City</label>
                                    <div>{result.city}<br/>
                                    </div>
                                </div>
                            </div>
                            <div class="row tab-section">
                                <div class="col-md-4">
                                    <label>Zip</label>
                                    <div>{result.zip}</div>
                                </div>
                                <div class="col-md-4">
                                    <label>State</label>
                                    <div>{result.state}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Best Contact Phone</label>
                                    <div>{result.work_phone}<br/>
                                    </div>
                                </div>
                                
 
                            </div>
                            <div class="row tab-section">


                                <div class="col-md-4">
                                    <label>Payment Status</label>
                                    <div>{result.payment_status==='NOTPAID'? 'PENDING':'PAID'}<br/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label>Payment Mode</label>
                                    <div>{result.payment_mode?result.payment_mode:null}<br/>
                                    </div>
                                </div>

                                
                                <div class="col-md-4">
                                    <label>Payment Details</label>
                                    <div>{result.payment_status? result.payment_details:null}<br/>
                                    </div>
                                </div>


                            </div>


                            <div className="list-action-wrpr showicons roundicons-text">
                                <div className="list-action-wrpr">
                                    <Link  to={"/official_edit/"+assid+'/'+id} data-toggle="tooltip" title="Edit"><i class="edit icon-pencil3"></i><span>Update</span></Link>

                                    <button onClick={()=> { DeleteOfficial(id) }} data-toggle="tooltip" style={{background:'#fff'}} title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
                                </div>
                                </div>
                           
                        </div>

                    </div>



                </div>
            </aside>
        </div>
    )
}

export default OfficialView;